module.exports = __webpack_public_path__ + "img/caste-the-origins-of-our-discontents.109fc71b.png";